import axios from 'lib/axios'

interface SkillIdealProfilePayload {
  skill_id: number
  weight: number
}

export const fetchUpdateSkillsIdealProfile = async (
  skillsTestId: number,
  skills: SkillIdealProfilePayload[],
) => {
  const response = await axios.put(
    `/ideal_profile/skills/update/${skillsTestId}`,
    { skills },
  )
  return response
}
